// papers#manage — one paper: inline title/abstract editing, the versions
// table, and uploading a new version.
import { registerPage } from "../first"
import { mountPaperFieldEditors } from "../paper_title"
import { mountPaperUploadApps } from "../paper_upload"
import { mountRowLinks } from "../row_links"

export const PapersManagePage = {
  onDomReady(): void {
    mountRowLinks()
    mountPaperUploadApps()
    mountPaperFieldEditors()
  },
}

registerPage("PapersManagePage", PapersManagePage)
